__turbopack_context__.v({
  "fill": "centered-page-loader-module__PmIlDW__fill",
  "fullScreen": "centered-page-loader-module__PmIlDW__fullScreen",
});
